module.exports = __webpack_public_path__ + "img/img1.637537de.jpg";